import { SearchProps } from 'antd/es/input';
import { Input, theme } from 'antd';
import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { curateString } from 'src/core/utils/object';

type ValidatedSearchProps = {
  validator?: (value: string) => boolean;
};

const { useToken } = theme;

const defaultValidator = (value: string) => {
  return !(value.trim().length === 0 && value.length > 0);
};

export const ValidatedSearch: FC<SearchProps & ValidatedSearchProps> = (props) => {
  const { token } = useToken();
  const { t } = useTranslation();
  const validator = props?.validator ?? defaultValidator;

  const [previousValue, setPreviousValue] = useState<string>('');
  const [validationErrorVisible, setValidationErrorVisible] = useState(false);

  return (
    <div>
      <Input.Search
        {...props}
        onSearch={(value) => {
          if (!props.onSearch) return;
          if (curateString(value) === curateString(previousValue) && value.trim().length > 0) return;
          if (validator(value)) {
            setValidationErrorVisible(false);
            setPreviousValue(curateString(value));
            return props.onSearch(curateString(value));
          } else {
            setValidationErrorVisible(true);
          }
        }}
      />

      <span
        style={{
          color: token.colorError,
          display: 'block',
          width: props.style?.width ?? '100%',
          visibility: validationErrorVisible ? 'visible' : 'hidden',
        }}
      >
        {t('PleaseEnterAValidSearchTerm')}
      </span>
    </div>
  );
};
